// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sGjpm3PV93dEvOjdmNM5{width:100%;height:100%;max-width:1024px;display:flex;flex-direction:column;justify-content:center;align-items:center}.sGjpm3PV93dEvOjdmNM5 .hreSVBfSRmlVVlT9CGNl{display:flex;justify-content:center;margin-bottom:1rem}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:1rem;height:100%;width:100%}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1 .hD8fcmzSPsx7bfyAHALb{flex:1 1 100%;height:100%;width:100%;text-align:center;display:flex;flex-direction:row;align-items:center;justify-content:center}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1 .hD8fcmzSPsx7bfyAHALb .WQhIfMrgFVBG_d2ZsB7i{flex:1 1 90%;height:100%;text-align:center}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1 .hD8fcmzSPsx7bfyAHALb .WQhIfMrgFVBG_d2ZsB7i .F3BpwmNtRiMy1F2jvY6A{height:100%;width:100%}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1 .hD8fcmzSPsx7bfyAHALb .WQhIfMrgFVBG_d2ZsB7i .F3BpwmNtRiMy1F2jvY6A svg{height:auto;width:auto}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1 .hD8fcmzSPsx7bfyAHALb .VWQWOleZt3Bnulhl4MIL{flex:1 1 250px}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1 .hD8fcmzSPsx7bfyAHALb .VWQWOleZt3Bnulhl4MIL button{width:100%}.sGjpm3PV93dEvOjdmNM5 .VHLzKG0ONcTciTWUcQE1 .hD8fcmzSPsx7bfyAHALb .VWQWOleZt3Bnulhl4MIL h3{margin-bottom:1rem;color:var(--color-sa-purple);border-radius:5px;background:var(--color-default-extra-light);padding:.4em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `sGjpm3PV93dEvOjdmNM5`,
	"switchWrapper": `hreSVBfSRmlVVlT9CGNl`,
	"contentWrapper": `VHLzKG0ONcTciTWUcQE1`,
	"content": `hD8fcmzSPsx7bfyAHALb`,
	"leftColumn": `WQhIfMrgFVBG_d2ZsB7i`,
	"diagram": `F3BpwmNtRiMy1F2jvY6A`,
	"rightColumn": `VWQWOleZt3Bnulhl4MIL`
};
export default ___CSS_LOADER_EXPORT___;
